import { render, staticRenderFns } from "./ProductsImageUploader.vue?vue&type=template&id=ba108bf4&"
import script from "./ProductsImageUploader.vue?vue&type=script&lang=ts&"
export * from "./ProductsImageUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsImageUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
